import { render, staticRenderFns } from "./SimpleListPopularDestinations.vue?vue&type=template&id=c97846c0&"
import script from "./SimpleListPopularDestinations.vue?vue&type=script&lang=js&"
export * from "./SimpleListPopularDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports